import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../utils/api'

export const useFacilityStore = defineStore('facility', () => {
  // State
  const facility = ref(null)
  const token = ref(localStorage.getItem('facility_token') || null)
  const settingsUnlocked = ref(false)

  // Getters
  const isAuthenticated = computed(() => !!token.value && !!facility.value)
  const facilityName = computed(() => facility.value?.name || '')
  const facilityCode = computed(() => facility.value?.code || '')
  const settings = computed(() => facility.value?.settings || { inactivityTimeout: 60 })

  // Actions
  async function login(code, password) {
    const response = await api.post('/auth/login', { code, password })

    if (response.success) {
      token.value = response.token
      facility.value = response.facility
      localStorage.setItem('facility_token', response.token)
      localStorage.setItem('facility_data', JSON.stringify(response.facility))
    }

    return response
  }

  async function verifyToken() {
    if (!token.value) return false

    try {
      const response = await api.get('/auth/verify')

      if (response.success) {
        facility.value = response.facility
        localStorage.setItem('facility_data', JSON.stringify(response.facility))
        return true
      }
    } catch {
      // Token invalid, clear it
      logout()
    }

    return false
  }

  function logout() {
    token.value = null
    facility.value = null
    settingsUnlocked.value = false
    localStorage.removeItem('facility_token')
    localStorage.removeItem('facility_data')
  }

  function unlockSettings() {
    settingsUnlocked.value = true
  }

  function lockSettings() {
    settingsUnlocked.value = false
  }

  // Initialize from localStorage
  function init() {
    const savedFacility = localStorage.getItem('facility_data')
    if (savedFacility && token.value) {
      try {
        facility.value = JSON.parse(savedFacility)
      } catch {
        logout()
      }
    }
  }

  init()

  return {
    // State
    facility,
    token,
    settingsUnlocked,

    // Getters
    isAuthenticated,
    facilityName,
    facilityCode,
    settings,

    // Actions
    login,
    verifyToken,
    logout,
    unlockSettings,
    lockSettings
  }
})
